import React from 'react';

const SummaryDashboard = ({ clientBehavioralData, triggers }) => {
  // Use triggers data if available, otherwise fall back to clientBehavioralData
  const triggerData = triggers && triggers.length > 0 ? triggers : 
                     (clientBehavioralData?.triggers || []);
  
  // Get conversation topics from clientBehavioralData or create a placeholder
  const conversationTopics = clientBehavioralData?.conversationTopics || [];
  
  // Get meeting agendas from clientBehavioralData or create a placeholder
  const meetingAgendas = clientBehavioralData?.meetingAgendas || [];
  
  // Find the highest priority trigger
  const highPriorityTrigger = triggerData.find(t => t.priority === 'High');
  
  return (
    <div className="border-t pt-6 mt-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Client Engagement Summary</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-blue-50 rounded-lg p-4">
          <div className="text-primaryDark text-sm font-medium mb-1">Active Triggers</div>
          <div className="text-xl font-bold text-gray-800">
            {triggerData.length}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {triggerData.filter(t => t.priority === 'High').length} high priority
          </div>
        </div>
        <div className="bg-green-50 rounded-lg p-4">
          <div className="text-green-600 text-sm font-medium mb-1">Conversation Topics</div>
          <div className="text-xl font-bold text-gray-800">
            {conversationTopics.length || triggerData.length}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Based on {triggerData.length} triggers
          </div>
        </div>
        <div className="bg-purple-50 rounded-lg p-4">
          <div className="text-purple-600 text-sm font-medium mb-1">Upcoming Meetings</div>
          <div className="text-xl font-bold text-gray-800">
            {meetingAgendas.length}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Next: {meetingAgendas[0]?.date || 'None scheduled'}
          </div>
        </div>
        <div className="bg-amber-50 rounded-lg p-4">
          <div className="text-amber-600 text-sm font-medium mb-1">Priority Action</div>
          <div className="text-xl font-bold text-gray-800 truncate">
            {highPriorityTrigger?.title || 'No high priority actions'}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {highPriorityTrigger?.status || ''}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryDashboard;